<!--
 * @Author: cgh
 * @Date: 2022-08-03 10:51:45
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:56:00
 * @Description: 评估明细
-->
<template>
  <!-- 页面头部 Start -->

  <!-- 页面头部 End -->
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-90 o-dialog--lg-90 o-dialog--xl-90 o-dialog-h--85"
    title="评估明细"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <!-- 查询条件 Start -->
    <div
      class="l-page l-page--search"
    >
      <div
        class="l-page__header c-page__header"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="78px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="14"
            >
              <el-form-item
                class="c-form__item"
                label="评估状态"
                prop="pgzt"
              >
                <el-radio-group v-model="filterParams.pgzt">
                  <el-radio label="">
                    全部
                  </el-radio>
                  <el-radio label="Y">
                    已完成
                  </el-radio>
                  <el-radio label="N">
                    未完成
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="10"
            >
              <el-form-item
                class="c-form__item"
                label="类型"
                prop="lx"
              >
                <el-select
                  v-model="filterParams.lx"
                  clearable
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lxType"
                    :key="item.id"
                    :value="item.id"
                    :label="item.text"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          class="c-page__header-btns"
          style="margin-left: 20px;"
        >
          <k-button
            btn-text="查询"
            :auth-type="false"
            type="primary"
            icon="kestrel-icon ki-search"
            @click="init()"
          />
          <k-button
            btn-text="重置"
            :auth-type="false"
            icon="kestrel-icon ki-repeat"
            @click="resetForm()"
          />
          <!-- 查询条件表单 End -->
        </div>
      </div>
      <!-- 查询条件 End -->
      <!-- 页面主内容：查询列表 Start -->
      <div
        class="l-page__body l-page--search__body"
      >
        <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
        <!-- table的ref的命名根据业务名称修改 -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="pgmxList.rows"
          :pagination="pgmxList"
          :pagination-show="true"
          :tooltip-effect="null"
          @current-change="init"
          @size-change="handleSizeChange"
        >
          <template
            #pdjg="scope"
          >
            {{ scope.row.pdjg || '/' }}
          </template>
          <template
            #df="scope"
          >
            {{ scope.row.df || '/' }}
          </template>
        </k-table>
      </div>
      <!-- -->
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgxmManageService } from '../pgxm.service.js';
export default {
  name: 'PgxmYwcDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      xmid: null,
      loading: false, // 页面是否加载
      fd: [],

      // 查询条件
      filterParams: {
        lx: null,
        pgzt: ''
      },
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'dxzbMc', label: '单项名称', align: 'left', minWidth: '80', type: 'text' },
        { key: 'zxzbMc', label: '子项名称', align: 'left', width: '120', type: 'text' },
        { key: 'jcnrMc', label: '检查内容', align: 'left', width: '80', type: 'text' },
        { key: 'jcxz', label: '检查细则', align: 'left', minWidth: '280', type: 'text' },
        { key: 'bh', label: '条文编号', align: 'left', width: '80', type: 'text' },
        { key: 'jcqk', label: '检查情况', align: 'left', width: '80', type: 'text' },
        { key: 'pdjg', slotName: 'pdjg', label: '评定结果', align: 'left', width: '80', type: 'text' },
        { key: 'df', slotName: 'df', label: '评定分数', align: 'left', width: '80', type: 'text' }

      ],
      /* 表格列配置End */
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */
      multipleSelectedRow: [], // 表格选中行（多选）
      pgmxList: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      }
    };
  },
  computed: {
    lxType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_AQLB) {
        return enums.IFF_AQLB;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.pgmxList.pageSize = val;
      this.init();
    },
    /**
     * @description: 表格选中行事件（多选）
     * @param {Object} val
     * @return {*}
     */
    handleSelectionChange (val) {
      this.multipleSelectedRow = val;
    },
    /**
     * 初始化数据
     */
    init () {
      this.loading = true;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      pgxmManageService.pgmxQuery(this.xmid, this.trueFilterParams)
        .then(rsp => {
          this.pgmxList = Object.assign({}, this.pgmxList, rsp.data);
        })
        .catch(err => {
          console.error('信息查询错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    }

  },
  created () {
    this.xmid = this.dlParams.id;
    if (this.dlParams.zt) {
      this.filterParams.pgzt = this.dlParams.zt;
    }
    this.init();
  }
};

</script>
<style scoped>
  .ma {
    margin-right: 100px;
  }
</style>
